export default __webpack_public_path__ + "static/media/cbeuax.833442c2.png";